module.exports = __webpack_public_path__ + "media/images/pic/saska/saska_kids-cda806174bc9a145746a4928268470af.png";